'use strict';

var Joi = require('joi');
var experimentsSchema_model = require('../utils/experimentsSchema.model.js');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var SignupPageSubmit = Joi__default["default"].object().keys({
  page_number: Joi__default["default"].number().min(1).required().description('Step in Onboarding Wizard'),
  email: Joi__default["default"].string().email({
    tlds: {
      allow: false
    }
  }).optional().description('Creator email'),
  username: Joi__default["default"].string().optional().description('Creator Username'),
  auth_method: Joi__default["default"].string().valid('google', 'email').required().description('Authentication method used by onboarding creator'),
  experiments: experimentsSchema_model,
  name: Joi__default["default"].string().optional().description('Creator Name'),
  content_categories: Joi__default["default"].array().items(Joi__default["default"].string()).optional().min(0).description('Creators content categories selections'),
  twitter_handle: Joi__default["default"].string().optional().allow(null).description('Creators Twitter Handle'),
  is_brand: Joi__default["default"].boolean().optional().default(false).description('Describes whether creator represents a brand, or is an individual.'),
  brand_name: Joi__default["default"].string().optional().allow(null).description('Name of the brand, if the creator onboarding has one.'),
  firstName: Joi__default["default"].string().optional().allow(null).description('First name of the creator.'),
  hype_kit_ref: Joi__default["default"].string().optional().allow(null).description('Selected Kit ID.'),
  instagram: Joi__default["default"].string().optional().allow(null).description('Instagram Link of creator.'),
  tiktok: Joi__default["default"].string().optional().allow(null).description('Tiktok Link of creator'),
  publisher_id: Joi__default["default"].string().guid({
    version: ['uuidv4']
  }).allow(null).optional().description('Publisher user logged into their account from')
}).description('This event fires in every form submit in the onboarding flow, which would be every user submit action.').meta({
  name: 'SignupPageSubmit',
  filename: 'signup:page_submit.model'
});
var SignupPageSubmit$1 = SignupPageSubmit;

module.exports = SignupPageSubmit$1;
//# sourceMappingURL=page_submit.model.js.map
